import * as React from 'react';

const TargetAudience = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={19} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1336-1248H584v8701h-1920z" />
            <g
                fillRule="nonzero"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.2}
                transform="translate(0 1)"
            >
                <circle cx={5.259} cy={3} r={3} />
                <path d="M7.747 8.25A4.5 4.5 0 0 0 .759 12m21.75 0a4.5 4.5 0 0 0-6.988-3.75" />
                <circle cx={18.009} cy={3} r={3} />
                <path d="M15.009 3s0 3.75-2.25 3.75M21.009 3s0 3.75 2.25 3.75" />
                <circle cx={11.259} cy={12} r={2.25} />
                <path d="M15.156 17.25a4.5 4.5 0 0 0-7.793 0" />
            </g>
        </g>
    </svg>
);
export default TargetAudience;
